import React, { PureComponent } from 'react';
import { Picture } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header, Eyebrow } from 'formlabs-web-components/Type';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import { withTranslation } from 'react-i18next';

import './Resources.module.css';
const FeaturedResource = DisplayComponent(
  class FeaturedResource extends PureComponent {
    render() {
      const { resource, classes, t } = this.props;
      return (
        <Grid direction="x">
          <Cell largeSize={12}>
            <Picture largeImage={resource.listing_image} fullBleed={true} />
          </Cell>
          <Cell
            largeSize={12}
            backgroundColor="blue"
            contentAlignment="align-children-middle"
          >
            <Cell>
              <Grid direction="x">
                <Cell largeSize={12} largeOffset={6}>
                  <div styleName="featured-copy" className={classes}>
                    <Eyebrow>{resource.type}</Eyebrow>{' '}
                    <div styleName="featured-title">
                      <Header level={2} displayAs={4}>
                        {resource.title}
                      </Header>
                    </div>
                    <Button to={resource.url} arrow="right" color="white">
                      {t('Learn More')}
                    </Button>
                  </div>
                </Cell>
              </Grid>
            </Cell>
          </Cell>
        </Grid>
      );
    }
  }
);

FeaturedResource.propTypes = {};

export default withTranslation()(FeaturedResource);
